const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const API = `${BACKEND_URL}/api`;

class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
    this.name = 'ApiError';
  }
}

export const api = {
  /**
   * Analyze user input and return deep patterns
   */
  async analyze(input, inputType = 'text', urlContent = null, fileContent = null, urlMetadata = null, urlHero = null) {
    const response = await fetch(`${API}/analyze`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        input,
        input_type: inputType,
        url_content: urlContent,
        file_content: fileContent,
        url_metadata: urlMetadata,
        url_hero: urlHero,
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new ApiError(
        error.detail || 'Analysis failed. Please try again.',
        response.status
      );
    }

    return response.json();
  },

  /**
   * Scrape URL content with enhanced signal extraction
   */
  async scrapeUrl(url) {
    const response = await fetch(`${API}/scrape-url`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new ApiError(
        error.detail || 'Failed to fetch URL content.',
        response.status
      );
    }

    return response.json();
  },

  /**
   * Upload and process file
   */
  async uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API}/upload-file`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new ApiError(
        error.detail || 'Failed to process file.',
        response.status
      );
    }

    return response.json();
  },

  /**
   * Get knowledge graph statistics
   */
  async getStats() {
    const response = await fetch(`${API}/kg-stats`);
    if (!response.ok) {
      throw new ApiError('Failed to fetch stats', response.status);
    }
    return response.json();
  },

  /**
   * Health check
   */
  async health() {
    const response = await fetch(`${API}/health`);
    return response.json();
  },

  /**
   * Submit feedback
   */
  async submitFeedback(analysisId, isHelpful, input, patternsCount) {
    const response = await fetch(`${API}/feedback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        analysis_id: analysisId,
        is_helpful: isHelpful,
        input,
        patterns_count: patternsCount,
      }),
    });
    return response.json();
  },
};

export default api;
